import logo from "../../media/branding/logo.png";
import "./PageLoader.css";

export default function PageLoader() {
    return (
        <div className="page-loader">
            <div className="page-loader__overlay" />
            <div className="page-loader__card">
                <img src={logo} alt="Dnevnik RG" className="page-loader__logo" />
                <div className="page-loader__spinner" />
                <h3 className="page-loader__title">Загружаем страницу</h3>
                <p className="page-loader__subtitle">Подготавливаем данные, это займет несколько секунд...</p>
            </div>
        </div>
    );
}
